import * as React from 'react'
import { useSettings } from '@axilon-apps/libs-ui-dashboard'

export type ObcTheme = 'bright' | 'day' | 'dusk' | 'night'

/**
 * Mirrors the active dashboard color scheme into the OpenBridge
 * `data-obc-theme` palette. Light scheme → `day`, dark scheme → `night`.
 *
 * Apply the returned value to a wrapper element via `data-obc-theme={theme}`
 * so OpenBridge styling stays scoped to the plant viewer.
 *
 * Previously read Joy's `useColorScheme` which exposed a `mode === 'system'`
 * branch; the dashboard Settings shape only stores the resolved `'light' |
 * 'dark'` value (system-following is handled at the provider level), so the
 * branch goes away here.
 */
export function usePlantObcTheme(): ObcTheme {
  const { settings } = useSettings()
  return React.useMemo<ObcTheme>(
    () => (settings.colorScheme === 'dark' ? 'night' : 'day'),
    [settings.colorScheme]
  )
}
